import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { ProfileFieldsBlock } from "@/react/components/shared/BuilderUI/constants/BlockCategories";
import { ContentProp } from "@/react/components/shared/BuilderUI/constants/PropCategories";

import { blockExists } from "../shared/blockExists";
import { FormContactNameBlock as Block } from "./FormContactNameBlock";
import { defaultData } from "./FormContactNameBlockDefaultData";

export const FormContactNameBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-user",
    size: 24,
  },
  meta: {
    name: "Name",
    nameI18n: "builder_ui.block_type.form_contact_name",
    version: 1,
    category: [ProfileFieldsBlock],
    isDisabled: blocks => blockExists(blocks, "FormContactNameBlock"),
    props: {
      label: {
        prop: "other",
        type: "string",
        name: "Label",
        nameI18n: "builder_ui.prop_type.label",
        category: [ContentProp],
      },
      placeholder: {
        prop: "other",
        type: "string",
        name: "Placeholder",
        nameI18n: "builder_ui.prop_type.placeholder",
        category: [ContentProp],
      },
      required: {
        prop: "other",
        type: "boolean",
        name: "Required",
        nameI18n: "builder_ui.prop_type.required",
        category: [ContentProp],
      },
    },
  },
};
